import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: true,
};

export const toggleSlice = createSlice({
  name: "toggle",
  initialState,
  reducers: {
    toggle: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { toggle } = toggleSlice.actions;

export default toggleSlice.reducer;
